import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AudienceSection } from './components/AudienceSection';
import { BottomSection } from './components/BottomSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-body text-gray-dark selection:bg-orange selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <AudienceSection data-id="element-5" />
        <BottomSection data-id="element-6" />
      </main>

      <Footer data-id="element-7" />
    </div>;
}